import { useKeyDownListener } from 'hooks/listeners/useKeyDownListener';
import { useMouseListener } from 'hooks/listeners/useMouseListener';
import { useContext, useEffect } from 'react';
import { CtxEdit } from 'session/ctxEdit';

export const useGlobalListeners = (wrapperMapRef, controlsRef) => {
    const { keyDown, keyDownHistory, keyDownMarkerMovement } = useKeyDownListener();
    const { mouseDown, mouseUp } = useMouseListener(wrapperMapRef, controlsRef);
    const ctxEdit = useContext(CtxEdit);

    const zoom = ctxEdit.mapRef?.current?.getZoom();

    useEffect(() => {
        if (ctxEdit.mapRef?.current) {
            window.addEventListener('keydown', keyDown);
        }
        return () => {
            window.removeEventListener('keydown', keyDown);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ctxEdit.selectedMarkers,
        ctxEdit.worldAction,
        ctxEdit.mapRef?.current,
        ctxEdit.selectedMarkers?.join(';'),
        zoom,
        ctxEdit
    ]);

    useEffect(() => {
        window.addEventListener('keydown', keyDownHistory);

        return () => {
            window.removeEventListener('keydown', keyDownHistory);
        };
    });

    useEffect(() => {
        window.addEventListener('keydown', keyDownMarkerMovement);

        return () => {
            window.removeEventListener('keydown', keyDownMarkerMovement);
        };
    });

    useEffect(() => {
        if (ctxEdit.mapRef?.current && wrapperMapRef.current) {
            ctxEdit.mapRef.current.on('mousedown', mouseDown);
            ctxEdit.mapRef.current.on('mouseup', mouseUp);
        }
        return () => {
            ctxEdit.mapRef?.current?.off('mousedown', mouseDown);
            ctxEdit.mapRef?.current?.off('mouseup', mouseUp);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        wrapperMapRef,
        controlsRef,
        ctxEdit.mapRef?.current,
        zoom,
        ctxEdit.selectedMarkers,
        ctxEdit.worldAction,
        ctxEdit.mouseDraggingSelection
    ]);
};
